module.exports = __webpack_public_path__ + "img/truebill.75672c1d.png";